import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { AuthService } from './auth.service';
import { environment } from '../../../environments/environment';

@Injectable()
export class BusinessUnitSettingsService {
  constructor(
    private httpClient: HttpClient,
    private authService: AuthService,
  ) {}

  getTermsAndConditionsLink(): Observable<string> {
    const headers = this.authService.getBearerRequestHeaders();
    return this.httpClient.get(
      `${environment.businessUnitSettingsServiceUrl}/termsAndConditions`,
      {
        headers,
        responseType: 'text',
      },
    );
  }
}
